import axios from 'axios'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getActiveClient } from 'shared/store/clients/selectors'
import { getPortalUserSummary } from 'Modules/Communication/PortalUsers/shared/api/portalUsers.api'
import { IPortalUserSummary } from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'

import {
  portalSummaryRequest,
  portalSummarySuccess,
  portalSummaryError,
} from '.'

function* fetchPortalSummary() {
  try {
    const { id } = yield select(getActiveClient)
    if (!id) throw Error('No client id available')

    const response: { data: IPortalUserSummary } = yield call(
      getPortalUserSummary,
      id
    )

    yield put(portalSummarySuccess(response.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e)
      yield put(portalSummaryError(e))
    }
  }
}

function* portalSummarySaga() {
  yield takeEvery(portalSummaryRequest.type, fetchPortalSummary)
}

export default portalSummarySaga
